
import {start_web_rtc, to_object} from "@/rd_sys_util_v2.2.min.js";

export default {

    data() {
        return {
            researchDefender: null
        }
    },

    methods: {

        runResearchDefender(surveyId, sessionId) {

            return new Promise((resolve, reject) => {

                start_web_rtc(3000)

                    .then(pass_params => {

                        const rdSearchRequest = new XMLHttpRequest();
                        const rdPublishableKey = "96176ded-792c-4e07-bbd3-a2ca9872996b";

                        let rdSearchEndpoint = "https://prod.rtymgt.com/api/v4/respondents/search/" + rdPublishableKey;

                        rdSearchEndpoint += "?sy_nr=" + surveyId + "&sn_ud=" + sessionId;
                        rdSearchEndpoint += "&" + pass_params;
                        rdSearchRequest.open("GET", rdSearchEndpoint);
                        rdSearchRequest.withCredentials = true;
                        rdSearchRequest.onreadystatechange = () => {
                            if (rdSearchRequest.readyState !== 4) return;

                            if (rdSearchRequest.status === 200) {
                                this.researchDefender = to_object(rdSearchRequest.responseText);
                                this.researchDefender.success = true;
                                resolve();
                            } else {
                                this.researchDefender.success = false;
                                reject("Research Defender execution failed");
                            }
                        };
                        rdSearchRequest.send();
                    })
                    .catch(error => {
                        console.error(error);
                        resolve();
                    });
            });
        }
    }
}